(() => {
  'use strict';

  class NiaHeroSlider {
    constructor(section) {
      this.section = section;
      this.slides = Array.from(section.querySelectorAll('.nia-hero-slide'));
      this.dots = Array.from(section.querySelectorAll('[data-slide-to]'));
      this.previousButton = section.querySelector('[data-slider-prev]');
      this.nextButton = section.querySelector('[data-slider-next]');
      this.current = 0;
      this.timer = null;
      this.startX = 0;
      this.autoplay = String(section.dataset.autoplay).toLowerCase() === 'true';
      this.delay = Math.max(Number(section.dataset.autoplaySpeed) || 6000, 1000);
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this.slides.length === 0) return;

      this.bindEvents();
      this.updateSlide(0);
      this.startAutoplay();
    }

    bindEvents() {
      if (this.previousButton) {
        this.previousButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.goTo(this.current - 1);
          this.restartAutoplay();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.goTo(this.current + 1);
          this.restartAutoplay();
        });
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          this.goTo(Number(dot.dataset.slideTo));
          this.restartAutoplay();
        });
      });

      this.section.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goTo(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        this.restartAutoplay();
      });

      this.section.addEventListener('mouseenter', () => this.stopAutoplay());
      this.section.addEventListener('mouseleave', () => this.startAutoplay());
      this.section.addEventListener('focusin', () => this.stopAutoplay());
      this.section.addEventListener('focusout', (event) => {
        if (!this.section.contains(event.relatedTarget)) this.startAutoplay();
      });

      this.section.addEventListener('touchstart', (event) => {
        this.startX = event.changedTouches[0].clientX;
      }, { passive: true });

      this.section.addEventListener('touchend', (event) => {
        const distance = this.startX - event.changedTouches[0].clientX;
        if (Math.abs(distance) < 40) return;
        this.goTo(this.current + (distance > 0 ? 1 : -1));
        this.restartAutoplay();
      }, { passive: true });
    }

    goTo(index) {
      const nextIndex = (index + this.slides.length) % this.slides.length;
      this.updateSlide(nextIndex);
    }

    updateSlide(index) {
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));

        if (isActive) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
        dot.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.current = index;
    }

    startAutoplay() {
      if (!this.autoplay || this.slides.length < 2 || this.reduceMotion.matches || document.hidden) return;
      this.stopAutoplay();
      this.timer = window.setInterval(() => {
        this.goTo(this.current + 1);
      }, this.delay);
    }

    stopAutoplay() {
      if (this.timer !== null) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    destroy() {
      this.stopAutoplay();
    }
  }

  function initializeSliders(root) {
    const sections = root.querySelectorAll
      ? root.querySelectorAll('.nia-hero-slider')
      : [];

    sections.forEach((section) => {
      if (!section.niaHeroSlider) {
        section.niaHeroSlider = new NiaHeroSlider(section);
      }
    });
  }

  function initialize() {
    initializeSliders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('.nia-hero-slider').forEach((section) => {
      const slider = section.niaHeroSlider;
      if (!slider) return;
      if (document.hidden) slider.stopAutoplay();
      else slider.startAutoplay();
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const slider = event.target.niaHeroSlider;
    if (slider) slider.destroy();
  });
})();
